// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DragDrop_dragDrop__dcRPr {
    display: grid;
    border-radius: 4em;
    width: auto;
    height: 100%;
    min-height: 150px;
    border-radius: 5px;
    grid-template-columns: repeat(auto-fill, 300px);
}

.DragDrop_isValidGroup__mNV5R {
    outline: 2px dashed var(--color-primary);
}

.DragDrop_isValidGroupNoOutline__UoVjm {
    outline: none;
}

.DragDrop_isInvalidGroup__tJlMF {
    opacity: .5;
}

.DragDrop_isInvalidGroup__tJlMF > * {
    pointer-events: none;
}

.DragDrop_isInvalidItem__oR7F4 {
    opacity: .5;
    pointer-events: none;
}

.DragDrop_currentItem__EPVjH {
    opacity: 0.5;
}

.DragDrop_dndGroup__HMJS6 {
    height: fit-content;
    width: 100%;
}

.DragDrop_dndGroup__HMJS6:not(:last-of-type) {
    padding-bottom: 8px !important; /* Spacing between DragDrop groups */
    border-bottom: 1px solid var(--color-lightui-accent-2);
}

.DragDrop_groupTitle__RMmLr {
    margin-left: 8px;
    color: var(--color-darkui-accent-2);
    font-size: 14px;
    user-select: none;
}

.DragDrop_groupCounter__87DwS {
    color: var(--color-darkui-accent-2);
    font-size: 12px;
    margin-left: 12px;
    user-select: none;
}

.DragDrop_groupHelperText__2XhEa {
    color: var(--color-darkui-accent-2);
    font-size: 12px;
    margin-left: 12px;
    user-select: none;
}

.DragDrop_dndItem__bY11n {
    display: flex;
    justify-content: center;
    min-height: 150px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
}

.DragDrop_dndItem__bY11n > * {
    user-select: none;
}

.DragDrop_dndItem__bY11n.DragDrop_isDragging__Pcw7L > * {
    pointer-events: none;
}

.DragDrop_draggable__YEgwB {
    cursor: move; /* fallback if grab cursor is unsupported */
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
}

.DragDrop_draggable__YEgwB:active {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
}

/* story styles */

.DragDrop_mockItem__9MLjJ {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid #E0E0E0;
}

.DragDrop_mockItem2__cwzkV {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 90%;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid #E0E0E0;
}

.DragDrop_mockItemWithClick__d3s42 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid #E0E0E0;
}

.DragDrop_deleteButton__s1MQt {
    align-self: self-end;
    margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/DragDrop/DragDrop.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,8BAA8B,EAAE,oCAAoC;IACpE,sDAAsD;AAC1D;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY,EAAE,2CAA2C;IACzD,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,iBAAiB;;AAEjB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":[".dragDrop {\n    display: grid;\n    border-radius: 4em;\n    width: auto;\n    height: 100%;\n    min-height: 150px;\n    border-radius: 5px;\n    grid-template-columns: repeat(auto-fill, 300px);\n}\n\n.isValidGroup {\n    outline: 2px dashed var(--color-primary);\n}\n\n.isValidGroupNoOutline {\n    outline: none;\n}\n\n.isInvalidGroup {\n    opacity: .5;\n}\n\n.isInvalidGroup > * {\n    pointer-events: none;\n}\n\n.isInvalidItem {\n    opacity: .5;\n    pointer-events: none;\n}\n\n.currentItem {\n    opacity: 0.5;\n}\n\n.dndGroup {\n    height: fit-content;\n    width: 100%;\n}\n\n.dndGroup:not(:last-of-type) {\n    padding-bottom: 8px !important; /* Spacing between DragDrop groups */\n    border-bottom: 1px solid var(--color-lightui-accent-2);\n}\n\n.groupTitle {\n    margin-left: 8px;\n    color: var(--color-darkui-accent-2);\n    font-size: 14px;\n    user-select: none;\n}\n\n.groupCounter {\n    color: var(--color-darkui-accent-2);\n    font-size: 12px;\n    margin-left: 12px;\n    user-select: none;\n}\n\n.groupHelperText {\n    color: var(--color-darkui-accent-2);\n    font-size: 12px;\n    margin-left: 12px;\n    user-select: none;\n}\n\n.dndItem {\n    display: flex;\n    justify-content: center;\n    min-height: 150px;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.dndItem > * {\n    user-select: none;\n}\n\n.dndItem.isDragging > * {\n    pointer-events: none;\n}\n\n.draggable {\n    cursor: move; /* fallback if grab cursor is unsupported */\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab;\n}\n\n.draggable:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n}\n\n/* story styles */\n\n.mockItem {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    border-radius: 5px;\n    background-color: white;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    border: 1px solid #E0E0E0;\n}\n\n.mockItem2 {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 90%;\n    border-radius: 5px;\n    background-color: white;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    border: 1px solid #E0E0E0;\n}\n\n.mockItemWithClick {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    width: 100%;\n    border-radius: 5px;\n    background-color: white;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);\n    border: 1px solid #E0E0E0;\n}\n\n.deleteButton {\n    align-self: self-end;\n    margin-right: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragDrop": `DragDrop_dragDrop__dcRPr`,
	"isValidGroup": `DragDrop_isValidGroup__mNV5R`,
	"isValidGroupNoOutline": `DragDrop_isValidGroupNoOutline__UoVjm`,
	"isInvalidGroup": `DragDrop_isInvalidGroup__tJlMF`,
	"isInvalidItem": `DragDrop_isInvalidItem__oR7F4`,
	"currentItem": `DragDrop_currentItem__EPVjH`,
	"dndGroup": `DragDrop_dndGroup__HMJS6`,
	"groupTitle": `DragDrop_groupTitle__RMmLr`,
	"groupCounter": `DragDrop_groupCounter__87DwS`,
	"groupHelperText": `DragDrop_groupHelperText__2XhEa`,
	"dndItem": `DragDrop_dndItem__bY11n`,
	"isDragging": `DragDrop_isDragging__Pcw7L`,
	"draggable": `DragDrop_draggable__YEgwB`,
	"mockItem": `DragDrop_mockItem__9MLjJ`,
	"mockItem2": `DragDrop_mockItem2__cwzkV`,
	"mockItemWithClick": `DragDrop_mockItemWithClick__d3s42`,
	"deleteButton": `DragDrop_deleteButton__s1MQt`
};
export default ___CSS_LOADER_EXPORT___;
